export default __webpack_public_path__ + "static/media/large.b24dad75.jpg";